__webpack_require__.p = "/schelling_point_denver2/";